import React from 'react';
import { actionButtonMap } from '../../../constants/actionButtonMap';
import SvgIcon from '../../SvgIcon/SvgIcon';
import { ActionItem } from '../../../types/button/ActionButton';

interface ActionButtonPanelProps {
  actions: ActionItem[];
  row?: any; // opcional, para pasar info contextual
  layout?: 'row' | 'column' | 'wrap'; // ➕ más explícito
  className?: string; // ➕ permite agregar estilos personalizados
}

const ActionButtonPanel: React.FC<ActionButtonPanelProps> = ({
  actions,
  row,
  layout = 'wrap',
  className = '',
}) => {
  const layoutClass =
    layout === 'column'
      ? 'flex-col'
      : layout === 'row'
      ? 'flex-row'
      : 'flex-wrap';

  return (
    <div className={`flex ${layoutClass} gap-3 ${className}`}>
      {actions.map((action, index) => {
        const config = actionButtonMap[action.key];
        if (!config) return null;

        return (
          <button
            key={index}
            onClick={() => action.onClick(row)}
            className={`inline-flex items-center gap-2 rounded px-4 py-2 text-sm font-medium text-white ${config.className}`}
          >
            {action.label ?? config.label}
            <SvgIcon name={config.iconName as any} className="h-4 w-4" />
          </button>
        );
      })}
    </div>
  );
};

export default ActionButtonPanel;
